module.exports = __webpack_public_path__ + "img/สาหร่ายวากาเมะ.3a84d229.jpg";